export default __webpack_public_path__ + "static/media/appointments.4a16714e.svg";